<template>
	<v-row
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "3"
			lg 	 = "4"
			md 	 = "5"
			sm 	 = "8"
			xs 	 = "12"
			cols ="12"
		>
			<v-card 
				outlined
				class = "elevation-5"
			>
				<v-card-title
					class = "body-2 secondary pa-1 white--text text-uppercase subtitle-1 font-weight-medium"
				>	
					<v-icon 
						
						color  = "white"
						class  = "ml-1 mr-2"
						@click = "$router.back()"
					> 
						mdi-arrow-left-circle
					</v-icon>
					<v-spacer></v-spacer>					
					<v-icon
						
						v-text = "head.icon"
						class  = "mx-1"
						:color = "head.color"
					></v-icon>
					<span v-text = "$ml.get(head.title)"></span>
					<v-chip 
						x-small 
						color  = "success"
						class  = "mx-2"
						v-show = "head.title1"
					>  
						{{ head.title1 }} 
					</v-chip>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text
					class = "pa-1 mt-1"
				>
					<v-row
					>
						<template
							v-for = "(item_field, idx_field) of info_fields"
						>
							<v-col
								:key = "idx_field"								
								cols = "12"
							>
								<v-text-field
									dense
									outlined
									hide-details = "auto"
									:label   = "$ml.get(item_field.text)"
									v-model  = "info[item_field.key]"
									:type    = "item_field.type"
									v-if  	 = "item_field.type == 'text' || item_field.type == 'number'"
									:rules 	 = "item_field.rules && item_field.rules.required ?  [item_field.rules.required] : [true]" 

								></v-text-field>
								<v-select
									outlined
									dense
									hide-details								
									v-model   	 = "info[item_field.key]"
									:label     	 = "$ml.get(item_field.text)"
									:items    	 = "render_listed(item_field.list)"
									v-else-if 	 = "item_field.type == 'select'"
									:item-value	 = "item_field.key_list"
									:item-text 	 = "item_field.text_list"
								></v-select>
								<v-menu 
									offset-y 
									bottom 
									:close-on-content-click = "false"
									v-if  					= "item_field.type == 'picker_color'"
									v-model 				= "menu[item_field.key]"
								> 
								    <template v-slot:activator = " { on: menu } ">
										<v-btn
											class  = "mx-2 pa-1"
											:color = "info[item_field.key]"	
											v-text = "$ml.get(item_field.text)"
											v-on   = "menu"   
										>

										</v-btn>
								 	</template>

								 	<v-color-picker 
									 	v-model = "info[item_field.key]"
									 	
								 	></v-color-picker>

								 	<v-btn
								 		x-small
								 		color  = "error"
								 		@click = "menu[item_field.key] = false"
								 	>
								 		{{ $ml.get('close')}}
								 	</v-btn>
								</v-menu>
								<v-card outlined 
									class 	  = "pa-0 caption pb-1" 
									height 	  = "40"
									v-else-if = "item_field.type == 'switch'"
								>
									<v-switch			
										dense						
										true-value
										hide-details
										class 			= "mt-1 ml-1"			
										:label 			= "$ml.get(item_field.text)"
										v-model 		= "info[item_field.key]"						
										:prepend-icon 	= "item_field.icon"
									></v-switch>
								</v-card>
							</v-col>
						</template>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-progress-linear
						indeterminate
						v-show = "loading"
						color  = "primary"
					></v-progress-linear>
					<v-spacer></v-spacer>
					<v-btn
						x-small
						color  = "primary"
						@click = "actions(action_title)"
						v-show = "!loading"
					>
						{{ $ml.get(action_title) }}						
					</v-btn>

				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>	
</template>
<script>
	export default {
		name : 'setting_lists',
		data : (vm) => ({
			info :  {
				color : '',
			},
			head : { 
				title : 'new_list',
				icon  : 'mdi-playlist-plus',
				color : 'success'
			},
			info_item : {},
			info_fields : [
				
				
				
				{
					key 	: 'name',
					text 	: 'name',
					type 	: 'text',		
					rules 	: {
          				required: value => !!value || 'Required.',
					}		
				},
				{
					key 	: 'type',
					text 	: 'type',
					type 	: 'select',	
					list 	: [ 'lpr', 'face', 'parking']			
				},
				{
					key 	: 'description',
					text 	: 'description',
					type 	: 'text',	
								
				},
				/*{
					key 	: 'sound',
					text 	: 'sound',
					type 	: 'select',
					list 	: 'list_sounds',		
					key_list 	: 'name',
					text_list	: 'name'
				},
				{
					key 	: 'isPopup',
					text 	: 'popup',
					type 	: 'switch',				
				},
				{
					key 	: 'color',
					text 	: 'color',
					type 	: 'picker_color',				
				},*/

			],			
			loading 		: false,
			action_title 	: 'save',
			list_sounds 	: [],
			menu 			: {
				color : false,
			},

		}), // data
		
		created(){
			let temp_sounds = this.$Helper.get_local('list_sounds');
			if (temp_sounds) {
				this.list_sounds = temp_sounds;
			}
			if (this.$route.name == 'listing_setting') {
				this.head.title   = 'listing_setting';
				this.head.icon 	  = 'mdi-playlist-edit'
				this.action_title = 'update';

				let local = this.$Helper.get_local('listing_setting');
				if (local) {
					this.info = local;
				}
			}
		
		}, // created

		methods : {

			actions(act, item, opt){
				if (act == 'save') {
					this.save()
				}
				if (act == 'update') {
					this.save(true)
				}

			}, // actions 


			save(up = false){ // save : false , update : true
				if (up) {
					if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_edit", "lists")) {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("lists"),
						})
						this.action_to_field.action = '1';
						return false;
					}
				}else{
					if (!this.$store.getters["auth/permission"]( this.$route.name || "lists", "can_add", "lists")) {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("lists"),
						})
						this.action_to_field.action = '1';
						return false;
					}
				}
				let opt = 'post';
				let info_up = this.info;
				let api 	= this.$URL + '/api/v1/list';
				let check  	= false;
				if (up) {
					opt = 'put';					
					if (info_up && info_up.id ) {
						api += '/' + info_up.id;
						check = true;

					}
				}else{
					check = true;
				}
				if (check ) {
					let valid 	= true;
					let req 	= this.$ml.get('required') + ' : ';
					if (!info_up.name) {
						req += (this.$ml.get('name')) + ', ';
						valid = false;
					}
					if (!info_up.type) {
						req += (this.$ml.get('type'));
						valid = false;

					}
					if (valid) {

						this.$axios[opt](api, info_up).then( res => {
							// console.log('res ', opt, 'list setting', res );
							this.$EventBus.$emit('notifications_modal',{
								type : up ? 'updated' : 'saved', 
							});
							this.loading = false;
							this.$router.back();
						}).catch(er => {
							this.loading = false;						
							console.log("Error list setting ", opt, er);
							let  err = up ? 'update ' : 'save ';
							err += er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  err
							});

						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type    : 'warning',
							message : req,
						});
					}

				}
			}, // save

			render_listed(item){
				if (item && typeof item != 'string'  && item.length > 0) {
					return item
				}else if (item && this[item]) {
					return this[item];
				}
				return [ this.$ml.get('data_no_found')]

			}, // render listed
		}
	}; // export default
</script>